import { render, staticRenderFns } from "./mobileGrowupBook.vue?vue&type=template&id=390b9c1e&scoped=true&"
import script from "./mobileGrowupBook.vue?vue&type=script&lang=js&"
export * from "./mobileGrowupBook.vue?vue&type=script&lang=js&"
import style0 from "./mobileGrowupBook.vue?vue&type=style&index=0&id=390b9c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b9c1e",
  null
  
)

export default component.exports